import { analyticsCookieDeletions, analyticsPage, createAnalytics, isAnalyticsHost, MEASUREMENT_ID, type AnalyticsEvent } from './lib/analytics';

type AnalyticsWindow = Window & { dataLayer?: unknown[]; gtag?: (...args: unknown[]) => void };
let runtime: ReturnType<typeof createAnalytics> | undefined;

export function clearAnalyticsCookies() {
  try {
    for (const cookie of analyticsCookieDeletions(document.cookie, location.hostname, location.protocol === 'https:')) document.cookie = cookie;
  } catch { /* Browsers may block cookie access; collection is already disabled. */ }
}

export function studioAnalytics() {
  if (runtime) return runtime;
  const target = window as AnalyticsWindow;
  runtime = createAnalytics({
    now: () => Date.now(),
    allowed: () => isAnalyticsHost(window.location.protocol, window.location.hostname),
    page: () => analyticsPage(window.location.pathname),
    disable: value => { (target as unknown as Record<string, unknown>)[`ga-disable-${MEASUREMENT_ID}`] = value; },
    command: (...args) => {
      target.dataLayer ??= [];
      target.gtag ??= function () { target.dataLayer!.push(arguments); };
      target.gtag(...args);
    },
    load: () => {
      if (document.getElementById('odaro-analytics-tag')) return;
      const script = document.createElement('script');
      script.id = 'odaro-analytics-tag'; script.async = true;
      script.referrerPolicy = 'no-referrer';
      script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
      document.head.append(script);
    },
    stop: () => {
      document.getElementById('odaro-analytics-tag')?.remove();
      target.dataLayer = [];
      delete target.gtag;
    },
    clearCookies: clearAnalyticsCookies,
  });
  return runtime;
}

export function trackAnalytics(event: AnalyticsEvent) {
  // No free-form parameters: form values, URLs and customer details never enter events.
  try { return studioAnalytics().track(event); } catch { return false; }
}
